import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-725a0420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"-85px !important"} }
const _hoisted_2 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<svg height=\"100\" width=\"100\" data-v-725a0420><circle stroke-linecap=\"round\" transform-origin=\"50 50\" cx=\"50\" cy=\"50\" r=\"40\" stroke-width=\"5\" stroke=\"white\" fill=\"none\" stroke-dasharray=\"125.66\" data-v-725a0420><animateTransform attributeName=\"transform\" type=\"rotate\" dur=\"1s\" to=\"360\" repeatCount=\"indefinite\" data-v-725a0420></animateTransform></circle><circle stroke-linecap=\"round\" transform-origin=\"50 50\" cx=\"50\" cy=\"50\" r=\"30\" stroke-width=\"5\" stroke=\"white\" fill=\"none\" stroke-dasharray=\"94.245\" data-v-725a0420><animateTransform attributeName=\"transform\" type=\"rotate\" dur=\".8s\" to=\"360\" repeatCount=\"indefinite\" data-v-725a0420></animateTransform></circle></svg>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "steper" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "fs-2 fw-bold" }
const _hoisted_8 = { class: "row mt-3" }
const _hoisted_9 = { class: "col-xs-12 col-sm-6 col-md-3 col-lg-3 text-center" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-xs-6 col-sm-2 col-md-2 col-lg-2 text-end fs-5" }
const _hoisted_12 = { class: "text-white" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-6 col-sm-10 col-md-10 col-lg-10 text-start" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 fw-bold" }, "Información"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-base subtitleSteper" }, "Del vehículo")
], -1))
const _hoisted_14 = { class: "col-xs-12 col-sm-6 col-md-3 col-lg-3 text-center" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-xs-6 col-sm-2 col-md-2 col-lg-2 text-end fs-5" }
const _hoisted_17 = { class: "text-white" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-6 col-sm-10 col-md-10 col-lg-10 text-start" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 fw-bold" }, "Imágenes"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-base subtitleSteper" }, "Galería del vehículo")
], -1))
const _hoisted_19 = { class: "col-xs-12 col-sm-6 col-md-3 col-lg-3 text-center" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-xs-6 col-sm-2 col-md-2 col-lg-2 text-end fs-5" }
const _hoisted_22 = { class: "text-white" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-6 col-sm-10 col-md-10 col-lg-10 text-start" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 fw-bold" }, "Descripción"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-base subtitleSteper" }, "Sobre el vehículo")
], -1))
const _hoisted_24 = { class: "col-xs-12 col-sm-6 col-md-3 col-lg-3 text-center" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-xs-6 col-sm-2 col-md-2 col-lg-2 text-end fs-5" }
const _hoisted_27 = { class: "text-white" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-6 col-sm-10 col-md-10 col-lg-10 text-start" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 fw-bold" }, "Estatus"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-base subtitleSteper" }, "Del vehículo")
], -1))
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_31 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_32 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_33 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_34 = { class: "botones" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "row fondo" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1))
const _hoisted_38 = { class: "col-5" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base fw-bold" }, " Regresar ", -1))
const _hoisted_40 = { class: "col-4 text-end" }
const _hoisted_41 = { class: "fs-base fw-bold" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1))
const _hoisted_43 = {
  class: "modal fade",
  id: "uploadVehicleModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "uploadVehicleRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered mw-400px" }
const _hoisted_45 = { class: "modal-content rounded" }
const _hoisted_46 = { class: "modal-header pb-0 border-0" }
const _hoisted_47 = { class: "fs-2 fw-bold mb-3 text-center mt-5 w-100" }
const _hoisted_48 = { class: "modal-body text-center pt-0" }
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = { class: "fs-5" }
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"swal2-icon swal2-success swal2-icon-show\" style=\"display:flex;\" data-v-725a0420><div class=\"swal2-success-circular-line-left\" style=\"background-color:rgb(25, 31, 38);\" data-v-725a0420></div><span class=\"swal2-success-line-tip\" data-v-725a0420></span><span class=\"swal2-success-line-long\" data-v-725a0420></span><div class=\"swal2-success-ring\" data-v-725a0420></div><div class=\"swal2-success-fix\" style=\"background-color:rgb(25, 31, 38);\" data-v-725a0420></div><div class=\"swal2-success-circular-line-right\" style=\"background-color:rgb(25, 31, 38);\" data-v-725a0420></div></div>", 1)
const _hoisted_52 = { class: "listaButtonsComplete text-center mt-2 w-100 p-0" }
const _hoisted_53 = { class: "mb-5" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Ver detalles", -1))
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VehicleForm = _resolveComponent("VehicleForm")!
  const _component_ImagesVehicle = _resolveComponent("ImagesVehicle")!
  const _component_DescripcionVehicle = _resolveComponent("DescripcionVehicle")!
  const _component_DesperfectosVehicle = _resolveComponent("DesperfectosVehicle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, [
          _createVNode(_component_router_link, { to: "/vehicles" }, {
            default: _withCtx(() => [
              _createVNode(_component_inline_svg, { src: "media/icons/iconsax/arrow-left.svg" })
            ]),
            _: 1
          }),
          _createTextVNode(_toDisplayString(_ctx.idToEdit != undefined ? "  Editar vehículo" : "  Nuevo vehículo"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.step == 1 ? 'activeSpan' : 'inactiveSpan')
              }, [
                _withDirectives(_createElementVNode("span", null, "1", 512), [
                  [_vShow, _ctx.step <= 1]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_12, "✓", 512), [
                  [_vShow, _ctx.step > 1]
                ])
              ], 2)
            ]),
            _hoisted_13
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.step == 2 ? 'activeSpan' : 'inactiveSpan')
              }, [
                _withDirectives(_createElementVNode("span", null, "2", 512), [
                  [_vShow, _ctx.step <= 2]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_17, "✓", 512), [
                  [_vShow, _ctx.step > 2]
                ])
              ], 2)
            ]),
            _hoisted_18
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.step == 3 ? 'activeSpan' : 'inactiveSpan')
              }, [
                _withDirectives(_createElementVNode("span", null, "3", 512), [
                  [_vShow, _ctx.step <= 3]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_22, "✓", 512), [
                  [_vShow, _ctx.step > 3]
                ])
              ], 2)
            ]),
            _hoisted_23
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.step == 4 ? 'activeSpan' : 'inactiveSpan')
              }, [
                _withDirectives(_createElementVNode("span", null, "4", 512), [
                  [_vShow, _ctx.step <= 4]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_27, "✓", 512), [
                  [_vShow, _ctx.step > 4]
                ])
              ], 2)
            ]),
            _hoisted_28
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _withDirectives(_createElementVNode("div", _hoisted_30, [
        _createVNode(_component_VehicleForm, {
          sendForm: _ctx.sendForm,
          onStepIValidation: _cache[0] || (_cache[0] = ($event: any) => (_ctx.stepIValidation($event))),
          dataEditVehicle: _ctx.dataEditVehicle
        }, null, 8, ["sendForm", "dataEditVehicle"])
      ], 512), [
        [_vShow, _ctx.step == 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_31, [
        _createVNode(_component_ImagesVehicle, {
          sendGalery: _ctx.sendGalery,
          onStepIIValidation: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stepIIValidation($event))),
          imgVehicle: _ctx.sendImagesEditVehicle
        }, null, 8, ["sendGalery", "imgVehicle"])
      ], 512), [
        [_vShow, _ctx.step == 2]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_32, [
        _createVNode(_component_DescripcionVehicle, {
          sendDescripcion: _ctx.sendDescripcion,
          onStepIIIValidation: _cache[2] || (_cache[2] = ($event: any) => (_ctx.stepIIIValidation($event))),
          sendDataDescription: _ctx.sendDataDescription
        }, null, 8, ["sendDescripcion", "sendDataDescription"])
      ], 512), [
        [_vShow, _ctx.step == 3]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_33, [
        _createVNode(_component_DesperfectosVehicle, {
          sendDesperfectos: _ctx.sendDesperfectos,
          onStepIVValidation: _cache[3] || (_cache[3] = ($event: any) => (_ctx.stepIVValidation($event))),
          sendImgDesperfecto: _ctx.sendImgDesperfecto
        }, null, 8, ["sendDesperfectos", "sendImgDesperfecto"])
      ], 512), [
        [_vShow, _ctx.step == 4]
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-xs-12 col-sm-6 col-md-3 col-lg-3", _ctx.step >= 1 ? 'activeBlue' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-xs-12 col-sm-6 col-md-3 col-lg-3", _ctx.step >= 2 ? 'activeBlue' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-xs-12 col-sm-6 col-md-3 col-lg-3", _ctx.step >= 3 ? 'activeBlue' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["col-xs-12 col-sm-6 col-md-3 col-lg-3", _ctx.step >= 4 ? 'activeBlue' : ''])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("button", {
            class: "btn btn-secondary mt-5 mb-5 btnIzq",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.regresar && _ctx.regresar(...args)))
          }, [
            _createVNode(_component_inline_svg, { src: "media/icons/iconsax/arrow-left.svg" }),
            _hoisted_39
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("button", {
            class: "btn btn-primary mt-5 mb-5",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.siguiente && _ctx.siguiente(...args)))
          }, [
            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.step == 4 ? "Finalizar" : "Siguiente"), 1),
            _createVNode(_component_inline_svg, { src: "media/icons/iconsax/arrow-right.svg" })
          ])
        ]),
        _hoisted_42
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("h1", _hoisted_47, _toDisplayString(_ctx.isEdit ? "Vehículo actualizado" : "Vehículo creado"), 1)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.isEdit
                    ? "Se ha actualizado de manera exitosa el vehículo"
                    : "Se ha registrado de manera exitosa el vehículo"), 1),
              _hoisted_51,
              _createElementVNode("ul", _hoisted_52, [
                _createElementVNode("li", _hoisted_53, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cerrarModal('/vehicles/' + _ctx.idAuto)))
                  }, _hoisted_55)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("span", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cerrarModal('/vehicles'))),
                    class: "text-white spanRegresar fs-base"
                  }, "Regresar al inicio")
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512)
  ]))
}